import axios from 'axios';
import { maxItemsPerPage, apiUrl } from './index';

export default {
  getItems(options = {}) {
    const { page = 1, perPage = maxItemsPerPage, user_type = 2, pending = 0, ...params } = options;

    params.page = page;
    params.user_type = user_type;
    params.pending = pending;

    if (perPage > -1) {
      params.per_page = perPage;
    }

    return axios({
      method: 'get',
      url: `${apiUrl}/users`,
      params,
    });
  },
  getUsersCount() {
    return axios({
      method: 'get',
      url: `${apiUrl}/users/external/count`,
    });
  },
  getInternalItems(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/users`,
      params,
    });
  },
  createUser(user) {
    return axios({
      method: 'post',
      url: `${apiUrl}/users`,
      data: {
        ...user,
      },
    });
  },
  updateUser(user) {
    return axios({
      method: 'put',
      url: `${apiUrl}/users/${user.id}`,
      data: {
        ...user,
      },
    });
  },
  updateUserOptions(user) {
    return axios({
      method: 'post',
      url: `${apiUrl}/users/${user.id}/options`,
      data: {
        ...user.options,
      },
    });
  },
  getItem({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/users/${id}`,
    });
  },
  getRoles(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/users/roles`,
      params
    });
  },
  getUsersRolesByCountry(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/users/search`,
      params
    });
  },
  getUserCountries() {
    return axios({
      method: 'get',
      url: `${apiUrl}/users/countries`,
    });
  },
  getUserStatuses() {
    return axios({
      method: 'get',
      url: `${apiUrl}/users/statuses`,
    });
  },
  getSettings({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/users/${id}/settings`,
    });
  },
  updateSettings({ id, settings }) {
    return axios({
      method: 'post',
      url: `${apiUrl}/users/${id}/settings`,
      data: {
        ...settings,
      },
    });
  },
  getNotifications({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/users/${id}/notifications`,
    });
  },
  addNotification({ id, ...rest }) {
    return axios({
      method: 'post',
      url: `${apiUrl}/users/${id}/notifications`,
      data: {
        ...rest,
      },
    });
  },
  removeNotification({ id, country_notify }) {
    return axios({
      method: 'delete',
      url: `${apiUrl}/users/${id}/notifications/${country_notify}`,
    });
  },
  getNotificationAccountTypes() {
    return axios({
      method: 'get',
      url: `${apiUrl}/users/notifications/account_types`,
    });
  },
  getAssignmentTypes() {
    return axios({
      method: 'get',
      url: `${apiUrl}/users/notifications/assignments`,
    });
  },
  logIntoAccount({ id }) {
    return axios({
      method: 'post',
      url: `${apiUrl}/users/${id}/login`,
    });
  },
  updateUserStatus({ id, status, reason }) {
    const data = {
      status,
      reason,
    };

    return axios({
      method: 'patch',
      url: `${apiUrl}/users/${id}/status`,
      data,
    });
  },
  getManagers(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/users/managers`,
      params,
    });
  },
  getAssignableUsers(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/users/assignable`,
      params,
    });
  },
  getSubRoles() {
    return axios({
      method: 'get',
      url: `${apiUrl}/business_users/roles`,
    });
  },
};
